import { FlatList as NbFlatList } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const FlatList = NbFlatList;

export default addWithConfig(FlatList);
